import { RecordDefinition } from "./recordDefinition.types";

/**
 * A page that posts to its own method with nothing to read back, e.g. quick start: it
 * is submitted once and then left, so there is no record to stay on.
 */
export const submitsOnce = (definition: RecordDefinition | undefined) =>
  Boolean(definition?.saveMethod && !definition.readMethod && !definition.readRecord);
